var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPointCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.46+435.748L418.019+415.67L419.923+384.688L437.578+368.764",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.847+458.25L455.405+438.172L457.309+407.189L474.964+391.265",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.979+434.537L437.751+456.173L419.576+414.978L456.271+437.479L421.654+385.38L458.694+405.977L437.578+369.456L474.445+392.823",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.46+435.748L418.019+415.67L419.923+384.688L437.578+368.764",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.109287,
    d: "M11.4511+32.318C11.4511+34.0555+9.94983+35.4639+8.09786+35.4639C6.24589+35.4639+4.74457+34.0555+4.74457+32.318C4.74457+30.5806+6.24589+29.1722+8.09786+29.1722C9.94983+29.1722+11.4511+30.5806+11.4511+32.318Z",
    fill: "currentColor",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.109287,
    d: "M35.231+46.1651C35.231+47.9025+33.7296+49.311+31.8777+49.311C30.0257+49.311+28.5244+47.9025+28.5244+46.1651C28.5244+44.4277+30.0257+43.0193+31.8777+43.0193C33.7296+43.0193+35.231+44.4277+35.231+46.1651Z",
    fill: "currentColor",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.109287,
    d: "M22.9863+39.4985C22.9863+41.2359+21.485+42.6443+19.633+42.6443C17.7811+42.6443+16.2797+41.2359+16.2797+39.4985C16.2797+37.7611+17.7811+36.3526+19.633+36.3526C21.485+36.3526+22.9863+37.7611+22.9863+39.4985Z",
    fill: "currentColor",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.109287,
    d: "M35.3778+17.7859C35.3778+19.5233+33.8764+20.9318+32.0245+20.9318C30.1725+20.9318+28.6712+19.5233+28.6712+17.7859C28.6712+16.0485+30.1725+14.6401+32.0245+14.6401C33.8764+14.6401+35.3778+16.0485+35.3778+17.7859Z",
    fill: "currentColor",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.109287,
    d: "M59.1576+31.633C59.1576+33.3704+57.6562+34.7789+55.8043+34.7789C53.9523+34.7789+52.451+33.3704+52.451+31.633C52.451+29.8956+53.9523+28.4872+55.8043+28.4872C57.6562+28.4872+59.1576+29.8956+59.1576+31.633Z",
    fill: "currentColor",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.109287,
    d: "M46.9129+24.9664C46.9129+26.7038+45.4116+28.1122+43.5596+28.1122C41.7077+28.1122+40.2063+26.7038+40.2063+24.9664C40.2063+23.2289+41.7077+21.8205+43.5596+21.8205C45.4116+21.8205+46.9129+23.2289+46.9129+24.9664Z",
    fill: "currentColor",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.109287,
    d: "M23.8793+24.1468C23.8793+25.8842+22.378+27.2927+20.526+27.2927C18.674+27.2927+17.1727+25.8842+17.1727+24.1468C17.1727+22.4094+18.674+21.0009+20.526+21.0009C22.378+21.0009+23.8793+22.4094+23.8793+24.1468Z",
    fill: "currentColor",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.109287,
    d: "M47.6591+37.9939C47.6591+39.7313+46.1578+41.1397+44.3058+41.1397C42.4538+41.1397+40.9525+39.7313+40.9525+37.9939C40.9525+36.2565+42.4538+34.848+44.3058+34.848C46.1578+34.848+47.6591+36.2565+47.6591+37.9939Z",
    fill: "currentColor",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.109287,
    d: "M35.4144+31.3272C35.4144+33.0646+33.9131+34.4731+32.0612+34.4731C30.2092+34.4731+28.7079+33.0646+28.7079+31.3272C28.7079+29.5898+30.2092+28.1814+32.0612+28.1814C33.9131+28.1814+35.4144+29.5898+35.4144+31.3272Z",
    fill: "currentColor",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPointCloud);
export default __webpack_public_path__ + "static/media/ic_point-cloud.288c0f88b839036667200fe34536629d.svg";
export { ForwardRef as ReactComponent };